export * from "./landing-page-info.component";
export * from "./landing-page-info-item.component";
